






  import Component from 'vue-class-component';
  import { NoElement } from '../../../../components';
  import { xComponentMixin } from '../../../../components/x-component.mixin';
  import FacetsMixin from '../facets.mixin';
  import { facetsXModule } from '../../x-module';

  /**
   * Provides a scoped slot with the selected filters from every facet, or from the facet which
   * facet id is passed as property.
   *
   * The default slot renders the length of the selected filters array.
   * The property "alwaysVisible" handles if the component is rendered if no filters are selected.
   *
   * @remarks It extends {@link FacetsMixin}.
   *
   * @public
   */
  @Component({
    mixins: [xComponentMixin(facetsXModule)],
    components: {
      NoElement
    }
  })
  export default class SelectedFilters extends FacetsMixin {}
